<template>
  <v-list>
    <v-list-item v-for="item in itens" :key="item.id">
      <tj-item-full 
        :item="item" 
        :selected="item.selected"
        class="my-1" 
        elevation="1" 
        show-icon
        text-height="20rem" 
        style="width:100%;"
        @view="onViewItem" />
    </v-list-item>
  </v-list>
</template>

<script>
import Vue from 'vue'
import "@/components/tj-item-full.vue"

export default Vue.component("tj-full-result", {
  props: {
    itens: Array,
    currentItem: Object
  },

  computed: {
    
  },

  methods: {
    onViewItem(item){
      this.$emit("view", item)
    }
  }

})
</script>
